<form [ngClass]="{'form-previously-submitted' : targetFormSubmitted}">
  <section class="sideRight-body bulk-delete__drawer">
    <h3>Do you wish to delete {{employees.length}} selected employees ?</h3>
    <br />
  </section>
  <footer class="endFormSubmit info-tile">
    <button type='button' class="btn btn-danger" [disabled]="isDisabled" (click)="deleteEmployees()">Delete Employees</button>
    <button type='button' class="btn kpmg-button--flat" (click)="rightSideDrawerService.closeRightSideDrawer()">Cancel</button>
  </footer>
</form>